/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import DashboardShell from "../dashboard/DashboardShell";
import { useStaticContext } from "../../context/StaticContext";
import { getOneCompany } from "../../lib/sysNavigation/SysNavigation";

const CompanyDash = () => {
  const { stats, getCompanyStats } = useStaticContext();
  const company = getOneCompany();
  const companyName = company?.name ?? "Company";
  const companyOwner = company?.owner_id;

  useEffect(() => {
    if (!stats && companyOwner) {
      getCompanyStats({ data: { ids: [companyOwner] } });
    }
  }, [stats, companyOwner]);

  return (
    <DashboardShell
      title={companyName}
      subtitle="Company · content footprint"
      stats={stats}
      clickRoute="/company"
      showTableStats={false}
      hideGeography
      breadCrumbDefault={false}
    />
  );
};

export default CompanyDash;
